import routes from '@/routes/routes';
import dynamic from 'next/dynamic';

const CustomRedirect = dynamic(() => import('@/components/CustomRedirect').then((m) => m.default), {
  ssr: false,
});

export default function Profile() {
  return <CustomRedirect to={routes.user('profile')} />;
}
